import { getProductImage, type Product } from '@/domain/Product.ts';
import styles from './AccessoryQuickViewContent.module.scss';
import Tags from '../Tags/Tags.tsx';
import ProductImage from '@/widgets/ProductList/cards/parts/ProductImage/ProductImage.tsx';
import QuickViewHeadingGroup from '../QuickViewHeadingGroup/QuickViewHeadingGroup.tsx';
import ContentsAndAllergens from '../ContentsAndAllergens/ContentsAndAllergens.tsx';

export type AccessoryQuickViewContentProps = {
  product: Product;
};

export default function AccessoryQuickViewContent({
  product
}: AccessoryQuickViewContentProps) {
  const image = getProductImage(product, 'main');

  return (
    <div
      class={styles.modalInner}
      tabIndex={0}
      role="region"
      aria-label={product.name}
    >
      <Tags product={product} />

      <ProductImage
        image={image}
        width={240}
        imagePolicy={{
          policyId: 'large',
          targetWidth: 240,
          density: 1
        }}
        loading="eager"
        class={styles.productImage}
      />

      <QuickViewHeadingGroup product={product} />

      <div class={styles.specsGroup}>
        <ContentsAndAllergens product={product} />
      </div>
    </div>
  );
}
